(function ($) {
  holidayShopProdCatV1 = {
    formatter: $('.holiday-shop-prod-cat-v1')
  };

  Drupal.behaviors.holidayShopProdCatV1 = {
    get: function (key) {
      return holidayShopProdCatV1[key];
    },

    set: function (key, val) {
      holidayShopProdCatV1[key] = val;
    },

    attach: function (context, settings) {
      this.context = context;
      // initHolidayShop();
    }
  };
  var initHolidayShop = function () {
    var undef;
    var context = Drupal.behaviors.holidayShopProdCatV1.context;

    // var category_products = page_data["category-input-type"].categories[0].products;
    // var category_products = page_data["category-input-type"];
    // var category_products = page_data["product-input-type"];

    $('.mpp-box[data-productid]', context).each(function () {
      var product_obj = Drupal.cl.tryGetObject(page_data, 'PRODUCT_ID', $(this).attr('data-productid'));
      // var product = $(Drupal.cl.tryGetObject(page_data, 'PRODUCT_ID', $(this).attr('data-productid'))).filter(function() {
      var product = $(product_obj).filter(function () {
        return this.priceRange !== undef;
      })[0];

      if (product !== undef) {
        $('.holiday-price-range', $(this)).html(product.priceRange);
      } else {
        // product = $(Drupal.cl.tryGetObject(page_data, 'PRODUCT_ID', $(this).attr('data-productid'))).filter(function() {
        product = $(product_obj).filter(function () {
          return this.skus !== undef && this.skus.length > 0;
        })[0];

        if (product !== undef && product.skus !== undef) {
          $('.holiday-price-range', $(this)).html(product.skus[0].formattedPrice);
        }
      }
    });

	  // Close qs
	  var quickShopClose = function () {
      if ($('#quickshop').css('display') == 'block') {
		  $('#quickshop-wrapper').remove();
		  $('.caret').addClass('hidden');
      }

      return;
	  };

	  // View toggle
	  $('.mpp-view-toggle a').on('click', function(e) {
      e.preventDefault();
      var self = $(this);

      quickShopClose();
      self.toggleClass('active').siblings().removeClass('active');
      $('ul#mpp-product-grid').toggleClass('view-small').toggleClass('view-large');
      $('ul#mpp-product-grid').find('img').toggleClass('threeup'); // product-image
	  });

	  var self = Drupal.behaviors.holidayShopProdCatV1;
	  var formatter = self.get('formatter');

	  formatter.each(function () {
      var thisFormatter = $(this);

      thisFormatter.find('.mpp-box.tout').replaceWith(thisFormatter.find('.mpp-box.tout').contents());
      // Placing the touts at the desired position between the products
      var touts = thisFormatter.parents('.holiday-cats').find('.holiday-tout');

      touts.each(function () {
		  var thisTout = $(this);
		  var myPosition = thisTout.attr('data-position');
		  var productsGrid = thisFormatter.find('#mpp-product-grid');
		  var products = productsGrid.children('li');
		  var holidayToutLi = $('<li>');// document.createElement('li');

		  $(holidayToutLi).addClass('mpp-box tout').append(thisTout);

		  if (typeof products[myPosition - 1] != 'undefined') {
          $(products[myPosition - 1]).before(holidayToutLi);
		  } else {
          productsGrid.append(holidayToutLi);
		  }
		  thisTout.removeClass('hidden');

		  // Describe what to-do for each tout
		  thisTout.find('a.action').on('click', function(e) {
          if ($(this).hasClass('link-tabbed')) { // Move the specified tab/menu
			  e.preventDefault();
			  var moveToTab = $(this).attr('href').replace('#', '');

			  $('#holiday-nav .menu[data-hashtag="' + moveToTab + '"]').trigger('click');
			  $('body, html').scrollTo('.holiday-nav-header', {
              duration: 500,
              axis: 'y'
			  });
          } else if ($(this).hasClass('link-overlay-tout')) { // Popup the video content
			  e.preventDefault();
			  var options = {
              includeBackground: true,
              includeCloseLink: true,
              hideOnClickOutside: true
			  };

			  options.content = $(this).parent('.overlay-tout').children('.popup').html();
			  options.cssClass = 'holiday_tout_promo_video';
			  generic.overlay.launch(options);
          }
		  });
      });

      // Handle quickshop
      thisFormatter.find('.btn-quickview').once('template-btn-quickview').on('click', function (e) {
		  e.preventDefault();
		  $('#quickshop .close').trigger('click');

		  var clickedProduct = $(this).closest('.mpp-box');
		  var qproduct_id = clickedProduct.find('.mpp-product-info').attr('data-productid');
		  var qsize_dd = clickedProduct.find('.mpp-product-info').attr('data-sizedd');
		  var qsWrapper = $('#quickshop-wrapper');

		  // Check if QS for this product is already open
		  if (qsWrapper.attr('data-productid') == qproduct_id) {
          // Close it
          qsWrapper.find('.close').trigger('click');
          setTimeout(function () {
			  qsWrapper.remove();
          }, 400);
		  } else {
          // Remove any others
          qsWrapper.remove();

          // Build new QS
          var qproduct = page_data['category-input-type'].categories[0].products.filter(function (p) {
			  return p.PRODUCT_ID === qproduct_id;
          })[0];

          qproduct['use_size_drop_down'] = qsize_dd ? 1 : 0;

          var $qs = site.quickshop.render({
			  productData: qproduct
          });

          $('div[data-productid="' + qproduct.PRODUCT_ID + '"] .caret').removeClass('hidden');
          placeAndDisplayQuickshop($qs, clickedProduct);
		  }
		  qsWrapper.find('.close').off('click').on('click', function() {
          qsWrapper.slideUp('500', function () {
			  qsWrapper.remove();
			  $('div[data-productid="' + product.PRODUCT_ID + '"] .caret').addClass('hidden');
          });
		  });
      });
	  });
  };
  var placeAndDisplayQuickshop = function (out, clickedProduct) {
    //
    // Place Quickshop in the right place.
    //
    var myParent = clickedProduct.parent('#mpp-product-grid');
    var mySiblings = myParent.find('li.mpp-box');
    var clickedLiIndex = mySiblings.index(clickedProduct);
    var ulWidth = myParent.width();
    var liWidth = $(clickedProduct).width();
    var numProducts = mySiblings.length;
    var productsPerRow = parseInt(ulWidth / liWidth);
    var numRows = numProducts / productsPerRow;

    if (numRows != parseInt(numRows)) {
      numRows = parseInt(numRows) + 1;
    }
    var rowClicked = parseInt(clickedLiIndex / productsPerRow) + 1;

    if (rowClicked != numRows) {
      var lastProdInClickedRowIndex = (rowClicked * productsPerRow) - 1;
    } else {
      var lastProdInClickedRowIndex = mySiblings.length - 1;
    }
    var lastProduct = mySiblings[lastProdInClickedRowIndex];
    // Create an LI that will contain the quickshop
    var qsWrapperLi = document.createElement('li');
    var qsProdId = clickedProduct.attr('data-productid');

    $(qsWrapperLi).attr('id', 'quickshop-wrapper').attr('data-productid', qsProdId).append(out);
    $(lastProduct).after(qsWrapperLi);

    //
    //  Display Quickshop in nice sliding animation
    //
    qs = $('#quickshop');
    var bottom_padding = 50;
    var speed = 500;
    var topPositionNavOffset = $('#top').height() + 40;

    qs.slideDown(speed, function () {
      var pos = qs.position();
      var window_height = $(window).height();
      var offset = qs.offset();
      var posY = offset.top - $(window).scrollTop();
      var clickedProductOffset = clickedProduct.offset();
      var clickedProductY = clickedProductOffset.top - $(window).scrollTop();
      var qs_bottom_position = posY + $('#quickshop-wrapper').height() + bottom_padding;

      // only scroll page if the quickshop fall within the viewable area
      if (qs_bottom_position > window_height) {
        /**
         * bottom of quickshop isn't visible, so let's formulate both options
         **/
        // option 1: place selected product near top of viewing area
        var prod_row = (clickedProductY - topPositionNavOffset) + $(window).scrollTop();
        // option 2: place quickshop within viewing area, sacrifice selected product in viewport if needed
        var quickshop_in_viewport = (qs_bottom_position - window_height) + $(window).scrollTop();
        // select our best option
        var scrollPosition = quickshop_in_viewport < prod_row ? prod_row : quickshop_in_viewport;

        // now scroll the window...
        $('body, html').scrollTo(scrollPosition, {
          duration: speed,
          axis: 'y'
        });
      }
    });
  };

  $(document).on('inventory_status_stored', function () {
    // weed out any products that lack 'isOrderable' or 'Coming Soon' skus
    $(page_data['category-input-type'].categories[0].products).each(function (i, product) {
      var isOrderableSku = $(product.skus).filter(function () {
        if (typeof $(document).data(this.SKU_ID) != 'undefined') {
          return ($(document).data(this.SKU_ID).isOrderable == 1) || ($(document).data(this.SKU_ID).INVENTORY_STATUS == 3);
        }
      })[0];
      var isDisplayableSku = $(product.skus).filter(function () {
        var undef;
        var sku = $(document).data(this.SKU_ID);

        return typeof site.features.spp_displayable_status !== 'undefined'
          && (sku !== undef && site.features.spp_displayable_status[sku.INVENTORY_STATUS]);
      })[0];

      if (typeof isOrderableSku == 'undefined' && !isDisplayableSku) {
        // remove product - removed completely so the quickshop positioning remains correct
        $('li.mpp-box[data-productid="' + product.PRODUCT_ID + '"]').remove();
      }
    });
    initHolidayShop();
  });
})(jQuery);
